import { errorToDefaultNotificationTranslationKey, SharedModalsProvider } from '@lessonup/typescript-core/client';
import { AppError } from '@lessonup/utils';
import { searchAppModalManagerService } from './SearchAppModalService';

const showDefaultErrorNotification = (error?: Error | AppError): void => {
  const translationKey = errorToDefaultNotificationTranslationKey(error);

  searchAppModalManagerService.open('notification', { translationKey });
};

export const sharedModalsProvider: SharedModalsProvider = { showDefaultErrorNotification };
